import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { TextInput } from "@common/textInput";
import { SelectList } from "@common/selectList";
import { SecondaryCriteriaIcon } from "@common/secondaryCriteriaIcon";
import { Button } from "@common/button";
import { PenIcon } from "@common/penIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function LinkForm({ value, readOnly, disabled, edit, submit }: Props) {
  const { t } = useTranslation();
  const [text, link] = value.split(":::");
  const [state, setState] = React.useState({
    text,
    link,
  });

  React.useEffect(() => {
    const [text, link] = value.split(":::");

    setState({ text, link });
  }, [value]);

  return readOnly ? (
    <div className={classNames(styles.linkForm, styles.readOnly)}>
      <Link className={styles.link} to={link} target="_blank">
        {text}
      </Link>
    </div>
  ) : (
    <div className={styles.linkForm}>
      <Link
        className={classNames(styles.link, { [styles.emptyLink]: !link })}
        to={link}
        target="_blank"
        onClick={(e) => !link && e.preventDefault()}
      >
        {!!text ? (
          text
        ) : (
          <SecondaryCriteriaIcon className={styles.icon} type="link" />
        )}
      </Link>
      <SelectList
        rootClassName={styles.inputRoot}
        listClassName={styles.listRoot}
        isDisabled={disabled}
      >
        {({ select }) => ({
          input: !disabled && <PenIcon className={styles.editIcon} />,
          list: (
            <div className={styles.url}>
              <div className={styles.group}>
                <p className={styles.label}>
                  {t("secondaryCriteriaForm.linkForm.link")}
                </p>
                <TextInput
                  value={state.link}
                  className={classNames(styles.input, {
                    [styles.disabled]: disabled,
                  })}
                  placeholder={location.origin}
                  isDisabled={disabled}
                  input={(link) => setState((s) => ({ ...s, link }))}
                  autoFocus
                />
              </div>
              <div className={styles.group}>
                <p className={styles.label}>
                  {t("secondaryCriteriaForm.linkForm.text")}
                </p>
                <TextInput
                  value={state.text}
                  className={classNames(styles.input, {
                    [styles.disabled]: disabled,
                  })}
                  placeholder="Planzone"
                  input={(text) => setState((s) => ({ ...s, text }))}
                  isDisabled={disabled}
                />
              </div>
              <Button
                type={"submit"}
                className={styles.submitButton}
                press={() => select(submit(`${state.text}:::${state.link}`))}
              >
                {t("secondaryCriteriaForm.linkForm.submit")}
              </Button>
            </div>
          ),
        })}
      </SelectList>
    </div>
  );
}

export { LinkForm };
